
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class BranchInBOMGrid extends Serenity.EntityGrid<BranchInBOMRow, any> {
        protected getColumnsKey() { return 'Inventory.BranchInBOM'; }
        protected getDialogType() { return BranchInBOMDialog; }
        protected getIdProperty() { return BranchInBOMRow.idProperty; }
        protected getInsertPermission() { return BranchInBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return BranchInBOMRow.localTextPrefix; }
        protected getService() { return BranchInBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}